import React from 'react';
import { Input } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { validationClasses } from '@/utils/errors';
import { fieldLengths } from '@/constants/fields';
import ColumnValidationError from '@/components/errors/ColumnValidationError';

const DatasourceInputField = ({
  disabled,
  entity,
  field,
  maxLength = fieldLengths.medium,
  onChange,
  saveErrors,
  text,
  type = 'custom',
}) => {
  const intl = useIntl();
  const error = saveErrors.find((e) => e.fields.includes(field));

  return (
    <ColumnValidationError
      error={error}
      htmlFor={`datasource_${entity}`}
      labelId={`save.dataset.datasource.${entity}`}
    >
      <Input
        className={validationClasses(error)}
        disabled={disabled}
        id={`datasource_${entity}`}
        maxLength={maxLength}
        onChange={(e) => onChange(e.target.value)}
        placeholder={intl.formatMessage({ id: `save.dataset.datasource.${entity}.placeholder` })}
        size="large"
        type={type}
        value={text || ''}
      />
    </ColumnValidationError>
  );
};

export default DatasourceInputField;
